var render = function render(){var _vm=this,_c=_vm._self._c;return _c('clip-loader',{staticClass:"mr-1",attrs:{"loading":_vm.loading,"color":"white","size":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }